export const brickCss = (
  config,
  index = [0,0],
) => {
  const configKeys = Object.keys(config);

  const customRules = configKeys.reduce((acc, key) => {
    if ([
      'brick_w',
      'brick_h',
      'brick_color',
    ].includes(key)) {
      return acc;
    }
    
    if (key.startsWith('brick_')) {
      const match = key.match(/^brick_\[(.+)\]/);
      if (match) {
        const v = value(config[key], index);
        if (v != null) acc[match[1]] = v;
        return acc;
      }
      const v = value(config[key], index);
      if (v != null) acc[key.replace('brick_', '')] = v;
    }
    return acc;
  }, {});

  return {
    width: value(config.brick_w, index) ?? '60px',
    height: value(config.brick_h, index) ?? '20px',
    backgroundColor: value(config.brick_color, index) ?? '#8B4513',
    ...customRules,
  }
};


export const wallCss = (
  config,
) => {
  return {
    gap: value(config.brick_gap),
    padding: value(config.brick_gap),
    backgroundColor: config.brick_gap_color
  }
};

export const rowCss = (
  config,
  index = [0, 0],
) => {
  const i = index[0]
  let transform
  if (config._bpl && config.stagger_offset) {
    const isStaggered = typeof config.stagger === 'function' ? config.stagger(i) : config.stagger
    const offset = config.stagger_offset(i)
    if (isStaggered && offset > 0) transform = `translateX(-${offset}px)`
  }
  return {
    gap: value(config.brick_gap, index),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    transform,
  }
};

/**
 * Calculate brick attribute value
 * 
 * @param {any} val       the value to calculate
 * @param {Array} index   the index of the brick in the wall matrix ([x, y])\
 * @param {boolean} raw   whether to return the raw value (stripped of -px)
 * 
 * @returns {any}      the calculated value
 */
export const value = (
  val,
  index = [0, 0],
  raw = false,
) => {
  if (val === undefined) {
    return undefined
  }
  let res = val;
  if (typeof val === 'function') {
    res = val(index);
  }
  
  if (raw) {
    return res
      .replace(/px$/, '')
      .replace(/%$/, '')
  } else {
    return res
  }

}
  
